@if (icon) {
  <icon name="{{icon}}"></icon>
}
<div class="value">{{value || '--'}}</div>